'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mutuallyExclusiveProps = {};

exports.__exports = mutuallyExclusiveProps;
